$ = jQuery.noConflict();

$(() => {

	$('form').on('change', 'input[type=number]', function() {
		if($(this).val() < 1){
			$(this).val(1);
		}
	});

});
